import React, { type MouseEvent } from 'react';
import CloseIcon from '@atlaskit/icon/core/migration/cross-circle';
import SearchIcon from '@atlaskit/icon/core/migration/search';
import { components, type DropdownIndicatorProps } from '@atlaskit/select';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import type { SelectOption } from '../../../../common/types.tsx';
import {
	DropdownIndicatorWrapper,
	CloseIconWrapper,
	DisplayWrapper,
} from '../../../../common/ui/picker/styled.tsx';

// EM-2028 TODO: We are rendering both icons and hiding them via CSS display rule because
// the Popup component's ref is not correctly updated when this react-select component
// rerenders. i.e. it does not  update the refs when one of these components rerenders.
export const DropdownIndicator = (props: DropdownIndicatorProps<SelectOption, boolean>) => (
	<components.DropdownIndicator {...props}>
		<DropdownIndicatorWrapper>
			<DisplayWrapper displayFlag={props.selectProps.inputValue}>
				<CloseIconWrapper
					data-testid="jql-builder-basic-picker.ui.async-select.select.dropdown-indicator.dropdown-close-icon"
					onClick={(event: MouseEvent) => {
						event.preventDefault();
						props.selectProps.onInputChange &&
							props.selectProps.onInputChange('', {
								action: 'input-change',
								prevInputValue: props.selectProps.inputValue,
							});
					}}
				>
					<CloseIcon LEGACY_size="small" label="" />
				</CloseIconWrapper>
			</DisplayWrapper>
			{!isVisualRefreshEnabled() && (
				<DisplayWrapper displayFlag={!props.selectProps.inputValue}>
					<SearchIcon LEGACY_size="small" label="" />
				</DisplayWrapper>
			)}
		</DropdownIndicatorWrapper>
	</components.DropdownIndicator>
);

export default DropdownIndicator;
